if (!customElements.get("vbb-wishlist")) {
  customElements.define(
    "vbb-wishlist",
    class Wishlist extends HTMLElement {
      constructor() {
        super();

        this.isLoading = true;
        this.emptyText = this.dataset.emptyText;
        this.itemsEl = this.querySelector('[data-items]');

        document.addEventListener('wishlist:fetch-lists:success', () => this.init());
      }

      init() {
        this.isLoading = true;
        this.classList.add('is-loading');

        if (!window.globalSwymWishlist?.lists[0]?.listcontents?.length) {
          this.renderEmpty();
          this.isLoading = false;
          this.classList.remove('is-loading');
          return
        }

        this.fetchItemCards().then((res) => {
          this.renderItems(res);

          if (typeof yotpoWidgetsContainer !== 'undefined') {
            yotpoWidgetsContainer.initWidgets();
          }

          this.isLoading = false;
          this.classList.remove('is-loading');
        });
      }

      fetchItemCards() {
        var sectionId = 'vbb-wishlist-item-card';

        var urls = window.globalSwymWishlist?.lists[0]?.listcontents.map((item) => {
          var itemProductHandle = item.du.split('/').pop();

          return `${Shopify.routes.root}products/${itemProductHandle}?variant=${item.epi}&section_id=${sectionId}`;
        });

        var promises = urls.map((url) => {
          return fetch(url)
            .then((res) => res.text())
            .then((res) => this.removeSectionWrapper(res));
        });

        return Promise.all(promises);
      }

      removeSectionWrapper(htmlString) {
        var parser = new DOMParser();
        var parserDocument = parser.parseFromString(htmlString, 'text/html');

        return parserDocument.body.firstElementChild.innerHTML;
      }

      renderItems(htmlStrings) {
        var itemsHtml = htmlStrings
          .map((htmlString) => {
            return `
              <div class="vbb-collection-grid__item">
                ${htmlString}
              </div>
            `;
          })
          .join('');

        var html = `
          <div class="vbb-collection-grid vbb-product-collection-grid vbb-product-collection-grid__items-4">
            ${itemsHtml}
          </div>
        `;

        this.itemsEl.innerHTML = html;
      }

      renderEmpty() {
        this.itemsEl.innerHTML = this.emptyText;
      }
    }
  );
}
